import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table, Spinner } from "react-bootstrap";
import PaginationLink from "../Components/PaginationLink";
import { GetTotalBlocks, getAllBlock, getBlocksCount } from "./ApiCall";
import InnerHTML from "dangerously-set-html-content";
import { useNavigate } from "react-router-dom";
import Loader from "../Pages/Loader";
import ScrollToTop from "../Components/ScrollToTop";

function Blocks() {
  const [blocks, setBlocks] = useState({ allBlock: [], totalBlocks: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [totalItems, setTotalItems] = useState([]);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    fetchData(currentPage);
    getTotalBlocks();
  }, [currentPage]);

  const fetchData = async (page) => {
    try {
      setLoading(true);
      const transactionResponse = await getAllBlock(page, itemsPerPage);
      setTotalItems(transactionResponse?.data?.totalItems);
      setBlocks((prevState) => ({
        ...prevState,
        allBlock: transactionResponse?.data?.data,
      }));
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const getTotalBlocks = async () => {
    try {
      const totalBlocksResponse = await GetTotalBlocks();
      setBlocks((prevState) => ({
        ...prevState,
        totalBlocks: totalBlocksResponse?.data?.count || [],
      }));
    } catch (error) {
      console.error("Error:", error.message);
    }
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  window.Navigateto = (tabName) => {
    navigate(tabName);
  };

  return (
    <>
      <div className="main-inner">
        <div className="container-fluid">
          <Row>
            <Container>
              <Row>
                <Col xl="12" md="12">
                  <h2> All Blocks</h2>
                </Col>
                <Col xl="12" md="12">
                  <div className="table-container">
                    <div className="table-inner-container">
                      <p className="heading-p">
                        A total of {totalItems} blocks from{" "}
                        {blocks.totalBlocks ?? "--"} blocks
                      </p>

                      {loading ? (
                        <div>
                          <Loader />
                        </div>
                      ) : error ? (
                        <div className="errorMsg">
                          <span>Failed to load Blocks Please Try Again.</span>
                        </div>
                      ) : (
                        <InnerHTML
                          key={blocks.allBlock}
                          html={blocks.allBlock}
                        />
                      )}

                      <div className="pagination-container">
                        <PaginationLink
                          itemsPerPage={itemsPerPage}
                          totalItems={totalItems}
                          onPageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Row>
        </div>
      </div>
      <ScrollToTop />
    </>
  );
}
export default Blocks;
